import { takeLatest } from 'redux-saga/effects';
import { loginSaga, logoutSaga, emailVerificationSaga, setPasswordSaga, loginClientAffiliateListSaga, forgotPasswordSaga, resetPasswordVerifySaga } from './authenticationSaga'; 
import { skillListSaga, skillAddSaga, skillEditSaga, skillUpdateSaga, skillDeleteSaga, superSubSectorListSaga } from './settings/superadmin/skillSaga';
import { sectorListSaga, sectorAllListSaga, sectorAddSaga, sectorEditSaga , sectorUpdateSaga, sectorDeleteSaga } from './settings/superadmin/sectorSaga';
import { subSectorListSaga, subSectorAllListSaga, subSectorAddSaga, subSectorEditSaga , subSectorUpdateSaga, subSectorDeleteSaga } from './settings/superadmin/subSectorSaga';
import { otherExpListSaga, otherExpAddSaga, otherExpEditSaga , otherExpUpdateSaga, otherExpDeleteSaga } from './settings/otherExpSaga';
import { clientCategoryMasterListSaga, clientCategoryMasterAddSaga, clientCategoryMasterEditSaga , clientCategoryMasterUpdateSaga, clientCategoryMasterDeleteSaga } from './settings/superadmin/clientCategorySaga';
import { clientCategoryListSaga, clientCategoryAddSaga, clientCategoryEditSaga , clientCategoryUpdateSaga, clientCategoryDeleteSaga } from './settings/affiliates/clientCategorySaga';

import { userDocMasterListSaga, userDocListSaga, userDocAddSaga, userDocEditSaga , userDocUpdateSaga, userDocDeleteSaga } from './settings/userDocSaga';

import { omuPointsListSaga, omuPointsSaveSaga } from './settings/superadmin/omnuPointsSaga';
import { travelFieldsMasterListSaga, travelFieldCreateSaga, travelFieldModifySaga, travelFieldDeleteSaga, affiliateTravelSettingsSaga } from './travelModuleSaga';

import { refreshTokenSaga} from './refreshTokenSaga';  
import { rolesListSaga, rolesAddSaga, rolesEditSaga, rolesUpdateSaga, rolesDeleteSaga, rolesPermissionUpdateSaga } from './rolesPermissionsSaga';  // roleaPermissionSaga 

import {affiliateProfileListSaga,affiliateCompanyInfoAddSaga,affiliateProfileEditSaga, affiliateCompanyInfoUpdateSaga,affiliateAddressUpdateSaga,affiliatePrimaryContactUpdateSaga,affiliateSettingsUpdateSaga,affiliateDeleteSaga } from './affiliateSaga';

import {aflt_skillListSaga, aflt_skillAddSaga, aflt_skillEditSaga, aflt_skillUpdateSaga, aflt_skillDeleteSaga, updateSkillIndexSaga,skillSuggestionSaga} from './settings/affiliates/aflt_skillSaga';

import {aflt_appayrateListSaga, aflt_appayrateAddSaga, aflt_appayrateUpdateSaga, aflt_appayrateDeleteSaga} from './settings/affiliates/aflt_appayrateSaga';  
import {keyLocationListSaga, keyLocationAddSaga, keyLocationDeleteSaga, eventLocationListSaga, eventLocationAddSaga,  eventLocationDeleteSaga, eventLocationCsvImportSaga} from './settings/affiliates/locationsSaga';  

import {aflt_skillSelListSaga, aflt_keyLocationListSaga, changePasswordSaga, locationSearchSaga, currencyListSaga,primaryContactListSaga, resendEmailSaga, getProfileRoleSaga, countryListSaga, timeZonesListSaga, serverTimeListSaga,inviteAsFriendSaga,loginAsUserSaga} from './commonSaga'; 

import {cancelReasonsMasterListSaga, cancelReasonsMasterAddSaga, cancelReasonsMasterLoadSaga, cancelReasonsMasterModifySaga, cancelReasonsMasterDeleteSaga, cancelReasonsListSaga, cancelReasonsAddSaga, cancelReasonsLoadSaga, cancelReasonsModifySaga, cancelReasonsDeleteSaga} from './cancelReasonsSaga'; 

import {aflt_stcbonusListSaga, aflt_stcbonusAddSaga, aflt_stcbonusUpdateSaga, aflt_stcbonusDeleteSaga} from './settings/affiliates/aflt_stcbonusSaga'; 

import {aflt_departmentListSaga, aflt_departmentAddSaga, aflt_departmentUpdateSaga, aflt_departmentDeleteSaga} from './settings/affiliates/aflt_departmentsSaga'; 

import {aflt_rateCardsListSaga, aflt_rateCardsAllSaga, aflt_rateCardsAddSaga, aflt_rateCardsUpdateSaga, aflt_rateCardsDeleteSaga,aflt_departmentRateCardsListSaga, aflt_departmentRateCardsUpdateSaga} from './settings/affiliates/aflt_rateCardsSaga'; 

import { copyCategoryToCategorySaga,copyMasterCardToClientSaga,aflt_masterratecardListSaga, aflt_masterratecardUpdateSaga, getAffiliateChiefBonusSaga, updateAffiliateChiefBonusSaga, getRateCardChiefBonusSaga, updateRateCardChiefBonusSaga, rateCardListSaga, rateCardUpdateSaga } from './settings/affiliates/aflt_masterratecardSaga'; 

import {clientBasicInfoSaga,clientFullListSaga,clientListForCategoriesSaga,profileClientCategoryListSaga,clientListSaga,clientQuickAddSaga,clientActiveDeactiveSaga,clientEditSaga,clientCompanyInfoAddSaga, clientPrmryConctAddSaga, clientCompanyInfoUpdateSaga, clientPrmryConctUpdateSaga,clientRateCardListSaga, clientRateCardUpdateSaga,clientContactListSaga, clientContactAddSaga, clientCsvImportSaga, clientCsvImportQuickFileSaga, clientContactCsvImportSaga,clientGetCrewChiefBonusSaga, clientUpdateCrewChiefBonusSaga,clientContactDeleteSaga,clientDepartmentsByClientIdSaga} from './clientSaga';

import {crewUnapprovedCountSaga,crewListSaga,crewAllListSaga,crewBasicInfoAddSaga, crewBasicInfoUpdateSaga, crewEditSaga, crewDeleteSaga, crewAvailabilitySaga, crewApproveSaga,crewSkillListSaga, crewSkillSaveSaga,crewChiefEligibilitySaga, crewAffSkillListSaga, crewCsvImportSaga, crewScheduleShiftStatusSaga, crewScheduleShiftCheckInSaga, crewScheduleShiftCheckOutSaga, crewRemovalFromShiftSaga,crewInductionSaga,crewListDownloadSaga,crewTimesheetListSaga, crewFeedbackListSaga, crewNotesListSaga, crewNotesAddSaga, crewNotesDocumentAddSaga, crewNotesDocumentDeleteSaga } from './crewSaga';

import {assMuteEmailSaga,assMutePushSaga, assUserActivateSaga, assUserEditSaga, assUserUpdateSaga, assUserDeleteSaga, associateUserDeleteSaga, assUserListSaga, assUserDepartmentListSaga, assUserRolesListSaga, assUserAddSaga} from './assUserSaga';
import {activityLogListSaga} from './activityLogSaga';

import { dynamicFieldsListSaga, dynamicFieldsdUpdateSaga, dynamicFieldsDataSaveSaga, dynamicFieldsMasterListSaga } from './settings/dynamicfieldsSaga'; 

import { documentListSaga, documentAddSaga, documentEditSaga, documentUpdateSaga, documentDeleteSaga, documentFileSaveSaga,
 documentFileDeleteSaga,skillDocumentListSaga,documentStatusUpdateSaga, passportFileSaveSaga, visaFileSaveSaga } from './documentSaga'; 

import { crewAvailabilityReportSaga,crewAvailSummaryReportListSaga,cancelReasonListSaga,removeAffVehicleShiftSaga,addAffVehicleShiftSaga,addRemoveVehicleShiftSaga,removeAffVehicleSaga,addAffVehicleSaga,availableAffVehicleSaga,invoicePreviewSaga,listInvoiceSaga,updateInvoiceSaga,addRemoveVehicleSaga,sendEventMessageSaga,listEventMessagesSaga,eventListSaga, eventAddSaga,eventEditSaga, eventUpdateSaga, quoteAcceptSaga, quoteDeclineSaga,eventClientListSaga,quoteEventLocationListSaga,eventDeleteSaga,quoteAssUserListSaga,shiftAddSaga,eventClientDetailsSaga,quoteSummarySaga,eventQuotePreviewSaga,eventSummarySaga,eventGetCrewChiefCountSaga,quoteSendtoClientSaga,eventUserActionLogsSaga,shiftIndividualDetailsSaga,shiftListSaga,quoteQuickUpdateSaga,quoteDownloadSaga,eventShiftUpdateSaga,eventClientAffiliateListSaga,shiftDeleteSaga,shiftEditSaga,quoteRequestSaga,eventCalendarListSaga,shiftSummarySaga,shiftScheduleListSaga,shiftGetDetailsSaga,shiftScheduleCrewSaga,shiftSkillCrewListSaga,shiftScheduleCrewRequestSaga,scheduleDateViewSaga,scheduleCrewViewSaga,eventCancelSaga,shiftCancelSaga,filterClientsListSaga,shiftsFilterEventsListSaga,shiftsFilterShiftsListSaga,shiftsFilterLocationsListSaga,eventsFilterEventsListSaga,eventsFilterLocationsListSaga,getNextShiftSeqNumberSaga,eventCompleteSaga,invoiceDownloadSaga,invoiceSendtoClientSaga,scheduleShiftCrewSaga,editQuoteDiscountSaga,eventListDownloadSaga,invoiceListDownloadSaga,filterAffiliatesListSaga,shiftSummaryAllCrewSaga,listEventShiftsSaga,listEventShiftCrewSaga,schedulesDateViewCalendarSaga,schedDateViewCalendarDateSaga,shiftCrewListDownloadSaga,shiftTimeChangeRequestSaga,getUnallocatedShiftsCountSaga,eventAffiliateDetailsSaga,clientDepartmentsByEventIdSaga, shiftCalendarEventsListSaga, shiftCalendarEventShiftsListSaga, generateInvoiceSaga, eventShiftsStaffListPDFDownloadSaga, shiftCalcDistanceDeptLocSaga } from './eventSaga';

import { timesheetSummaryCSVDownloadSaga,timesheetFilterCrewsSaga,timesheetFilterSkillsSaga,timesheetFilterDepartmentsSaga,timesheetFilterLocationsSaga,timesheetListSaga,timesheetDetailsSaga,timesheetUpdateSaga,timesheetFilterEventsSaga,timesheetShiftListSaga,timesheetCSVDownloadSaga} from './timesheetSaga';
import { feedbackListSaga,feedbackDetailsSaga,feedbackUpdateSaga,feedbackUpdateStarRatingSaga,feedbackGetChiefReviewersListSaga,actionTakenShiftGetSaga,actionTakenShiftUpdateSaga,actionTakenCrewGetSaga,actionTakenCrewUpdateSaga} from './feedbackSaga';
import { getUnavailabilitySaga,deleteUnavailabilitySaga,updateUnavailabilitySaga,saveUnavailabilitySaga,crewUnavailabilitySaga,crewUnavailabilityPerDateSaga,unavailableCrewListSaga} from './unavailabilitySaga';

import { fcmNotifiTokenSaveSaga,fcmNotificationSendSaga,notificationsFetchSaga, notificationReadSaga, notificationsFetchDropDownSaga, notificationsAllMarkAsReadSaga } from './fcmSaga'; 

import { dashboardActionRequiredListSaga,dashboardChartDataListSaga,dashboardClientActionRequiredListSaga, dashboardClientChartDataListSaga, shiftTimeChangeRequestCountSaga } from './dashboardSaga'; 

import { feedbackFilterEventsListSaga,feedbackFilterReviewersListSaga } from './filterSaga';

import {payLevelsAddSaga, payLevelsEditSaga, payLevelsDeleteSaga, payLevelsListSaga,payLevelsUpdateSaga} from './settings/affiliates/payLevelSaga';
import {ppSettingsAddSaga, ppSettingsEditSaga, ppSettingsDeleteSaga, ppSettingsListSaga,ppSettingsUpdateSaga} from './settings/superadmin/ppSettingSaga';

import { getSAProfileDetailsSaga,updateSAProfileDetailsSaga } from './superAdminSaga';

import { certificatesListSaga } from './settings/affiliates/certificateSaga';

import { validateClientAddSaga, validateClientDetailsSaga, validateEventAddSaga, validateCrewAddSaga, validateCrewDetailsSaga } from './validateSaga';

import { getVehicleInfoSaga,listFieldDetailsSaga,saveFieldDetailsSaga,deleteFieldDetailsSaga, listVehicleInfoSaga,saveVehicleInfoSaga,deleteVehicleInfoSaga,updateVehicleInfoSaga } from './vehicleInfoSaga';
import { listVehicleFieldsMasterSaga, addVehicleFieldaMasterSaga, updateVehicleFieldaMasterSaga, deleteVehicleFieldsMasterSaga } from './settings/superadmin/vehicleInfoMasterSaga'; 

import { termsFetchSaga, termsAddSaga, termsUpdateSaga, termsLoadSaga, termsAcceptSaga } from './termsSaga';

import { csvTemplateImportSaga } from "./settings/csvTemplatesImportSaga"; 

import * as types from '../actions';

export default function* watchUserAuthentication() {
  yield takeLatest(types.LOGIN_USER, loginSaga);
  yield takeLatest(types.LOGOUT_USER, logoutSaga); 
  yield takeLatest(types.FORGOT_PASSWORD, forgotPasswordSaga);  
  yield takeLatest(types.RESET_PASSWORD_VERIFICATION, resetPasswordVerifySaga);  

  yield takeLatest(types.SUPERADMIN_SKILL_LIST, skillListSaga);
  yield takeLatest(types.SUPERADMIN_SKILL_ADD, skillAddSaga);
  yield takeLatest(types.SUPERADMIN_SKILL_EDIT, skillEditSaga);
  yield takeLatest(types.SUPERADMIN_SKILL_UPDATE, skillUpdateSaga);
  yield takeLatest(types.SUPERADMIN_SKILL_DELETE, skillDeleteSaga);
  yield takeLatest(types.SUPERADMIN_SUBSECTOR_LIST, superSubSectorListSaga);

  yield takeLatest(types.EMAIL_VERIFICATION, emailVerificationSaga);
  yield takeLatest(types.SET_PASSWORD, setPasswordSaga);

  yield takeLatest(types.REFRESH_TOKEN, refreshTokenSaga)
  
  yield takeLatest(types.ROLES_LIST, rolesListSaga)
  yield takeLatest(types.ROLES_ADD, rolesAddSaga)
  yield takeLatest(types.ROLES_EDIT, rolesEditSaga)
  yield takeLatest(types.ROLES_UPDATE, rolesUpdateSaga)
  yield takeLatest(types.ROLES_DELETE, rolesDeleteSaga)
  yield takeLatest(types.ROLES_PERMISSION_UPDATE, rolesPermissionUpdateSaga)  

  yield takeLatest(types.SECTOR_LIST_SUPERADMIN, sectorListSaga);
  yield takeLatest(types.SECTOR_ALL_SUPERADMIN_LIST, sectorAllListSaga);
  yield takeLatest(types.SECTOR_ADD_SUPERADMIN, sectorAddSaga);
  yield takeLatest(types.SECTOR_EDIT_SUPERADMIN, sectorEditSaga);
  yield takeLatest(types.SECTOR_UPDATE_SUPERADMIN, sectorUpdateSaga);
  yield takeLatest(types.SECTOR_DELETE_SUPERADMIN, sectorDeleteSaga);

  yield takeLatest(types.SUBSECTOR_LIST_SUPERADMIN, subSectorListSaga);
  yield takeLatest(types.SUBSECTOR_ALL_LIST_SUPERADMIN, subSectorAllListSaga);
  yield takeLatest(types.SUBSECTOR_ADD_SUPERADMIN, subSectorAddSaga);
  yield takeLatest(types.SUBSECTOR_EDIT_SUPERADMIN, subSectorEditSaga);
  yield takeLatest(types.SUBSECTOR_UPDATE_SUPERADMIN, subSectorUpdateSaga);
  yield takeLatest(types.SUBSECTOR_DELETE_SUPERADMIN, subSectorDeleteSaga);

  yield takeLatest(types.OTHER_EXP_LIST, otherExpListSaga);
  yield takeLatest(types.OTHER_EXP_ADD, otherExpAddSaga);
  yield takeLatest(types.OTHER_EXP_EDIT, otherExpEditSaga);
  yield takeLatest(types.OTHER_EXP_UPDATE, otherExpUpdateSaga);
  yield takeLatest(types.OTHER_EXP_DELETE, otherExpDeleteSaga);

  yield takeLatest(types.CLIENT_CATEGORY_MASTER_LIST, clientCategoryMasterListSaga);
  yield takeLatest(types.CLIENT_CATEGORY_MASTER_ADD, clientCategoryMasterAddSaga);
  yield takeLatest(types.CLIENT_CATEGORY_MASTER_EDIT, clientCategoryMasterEditSaga);
  yield takeLatest(types.CLIENT_CATEGORY_MASTER_UPDATE, clientCategoryMasterUpdateSaga);
  yield takeLatest(types.CLIENT_CATEGORY_MASTER_DELETE, clientCategoryMasterDeleteSaga);

  yield takeLatest(types.CLIENT_CATEGORY_LIST, clientCategoryListSaga);
  yield takeLatest(types.CLIENT_CATEGORY_ADD, clientCategoryAddSaga);
  yield takeLatest(types.CLIENT_CATEGORY_EDIT, clientCategoryEditSaga);
  yield takeLatest(types.CLIENT_CATEGORY_UPDATE, clientCategoryUpdateSaga);
  yield takeLatest(types.CLIENT_CATEGORY_DELETE, clientCategoryDeleteSaga);

  yield takeLatest(types.USER_DOC_MASTER_LIST, userDocMasterListSaga);
  yield takeLatest(types.USER_DOC_LIST, userDocListSaga);
  yield takeLatest(types.USER_DOC_ADD, userDocAddSaga);
  yield takeLatest(types.USER_DOC_EDIT, userDocEditSaga);
  yield takeLatest(types.USER_DOC_UPDATE, userDocUpdateSaga);
  yield takeLatest(types.USER_DOC_DELETE, userDocDeleteSaga);

  yield takeLatest(types.OMNU_POINTS_LIST, omuPointsListSaga);
  yield takeLatest(types.OMNU_POINTS_SAVE, omuPointsSaveSaga);  

  yield takeLatest(types.SA_TRAVEL_FIELDS_MASTER_LIST, travelFieldsMasterListSaga);
  yield takeLatest(types.SA_TRAVEL_FIELDS_MASTER_CREATE, travelFieldCreateSaga);
  yield takeLatest(types.SA_TRAVEL_FIELDS_MASTER_MODIFY, travelFieldModifySaga);
  yield takeLatest(types.SA_TRAVEL_FIELDS_MASTER_DELETE, travelFieldDeleteSaga);

  yield takeLatest(types.AFFILIATE_TRAVEL_SETTINGS_LIST, affiliateTravelSettingsSaga);

  yield takeLatest(types.AFFILIATE_COMPANYINFO_ADD, affiliateCompanyInfoAddSaga);  
  yield takeLatest(types.AFFILIATE_EDIT, affiliateProfileEditSaga);  
  yield takeLatest(types.AFFILIATE_CMPNY_INFO_UPDATE, affiliateCompanyInfoUpdateSaga);
  yield takeLatest(types.AFFILIATE_DELETE, affiliateDeleteSaga);
  
  yield takeLatest(types.AFFILIATES_LIST, affiliateProfileListSaga);
  yield takeLatest(types.AFFILIATE_ADDRESS_UPDATE, affiliateAddressUpdateSaga);
  yield takeLatest(types.AFFILIATE_PRMRY_CNT_UPDATE, affiliatePrimaryContactUpdateSaga);
  yield takeLatest(types.AFFILIATE_SETTINGS_UPDATE, affiliateSettingsUpdateSaga);
  

  yield takeLatest(types.SKILL_LIST_AFFILIATE, aflt_skillListSaga);
  yield takeLatest(types.SKILL_ADD_AFFILIATE, aflt_skillAddSaga);
  yield takeLatest(types.SKILL_EDIT_AFFILIATE, aflt_skillEditSaga);
  yield takeLatest(types.SKILL_UPDATE_AFFILIATE, aflt_skillUpdateSaga);
  yield takeLatest(types.SKILL_DELETE_AFFILIATE, aflt_skillDeleteSaga);
  
  yield takeLatest(types.MASTER_LOCATION_LIST, locationSearchSaga);
  yield takeLatest(types.LIST_CURRENCY, currencyListSaga);
  yield takeLatest(types.LIST_PRMY_CNCT, primaryContactListSaga);

  yield takeLatest(types.APPAYRATE_LIST_AFFILIATE, aflt_appayrateListSaga);
  yield takeLatest(types.APPAYRATE_ADD_AFFILIATE, aflt_appayrateAddSaga);
  yield takeLatest(types.APPAYRATE_UPDATE_AFFILIATE, aflt_appayrateUpdateSaga);
  yield takeLatest(types.APPAYRATE_DELETE_AFFILIATE, aflt_appayrateDeleteSaga); 

  yield takeLatest(types.SKILL_SEL_LIST_AFFILIATE, aflt_skillSelListSaga); 
  yield takeLatest(types.STCBONUS_LIST_AFFILIATE, aflt_stcbonusListSaga); 
  yield takeLatest(types.STCBONUS_ADD_AFFILIATE, aflt_stcbonusAddSaga); 
  yield takeLatest(types.STCBONUS_UPDATE_AFFILIATE, aflt_stcbonusUpdateSaga); 
  yield takeLatest(types.STCBONUS_DELETE_AFFILIATE, aflt_stcbonusDeleteSaga); 

  yield takeLatest(types.KEY_LOCATION_LIST, keyLocationListSaga);
  yield takeLatest(types.KEY_LOCATION_ADD, keyLocationAddSaga);
  yield takeLatest(types.KEY_LOCATION_DELETE, keyLocationDeleteSaga);

  yield takeLatest(types.EVENT_LOCATION_LIST, eventLocationListSaga);
  yield takeLatest(types.EVENT_LOCATION_ADD, eventLocationAddSaga);
  yield takeLatest(types.EVENT_LOCATION_DELETE, eventLocationDeleteSaga);
  yield takeLatest(types.EVENT_LOCATION_IMPORT, eventLocationCsvImportSaga);

  yield takeLatest(types.KEY_LOC_LIST_AFFILIATE, aflt_keyLocationListSaga);
  yield takeLatest(types.DEPARTMENT_LIST_AFFILIATE, aflt_departmentListSaga);
  yield takeLatest(types.DEPARTMENT_ADD_AFFILIATE, aflt_departmentAddSaga);
  yield takeLatest(types.DEPARTMENT_UPDATE_AFFILIATE, aflt_departmentUpdateSaga);
  yield takeLatest(types.DEPARTMENT_DELETE_AFFILIATE, aflt_departmentDeleteSaga);
  
  yield takeLatest(types.RATE_CARDS_LIST_AFFILIATE, aflt_rateCardsListSaga);
  yield takeLatest(types.RATE_CARDS_ALL_AFFILIATE, aflt_rateCardsAllSaga);
  yield takeLatest(types.RATE_CARDS_ADD_AFFILIATE, aflt_rateCardsAddSaga);
  yield takeLatest(types.RATE_CARDS_UPDATE_AFFILIATE, aflt_rateCardsUpdateSaga);
  yield takeLatest(types.RATE_CARDS_DELETE_AFFILIATE, aflt_rateCardsDeleteSaga);
  yield takeLatest(types.DEPT_RATECARDS_LIST, aflt_departmentRateCardsListSaga);
  yield takeLatest(types.DEPT_RATECARDS_UPDATE, aflt_departmentRateCardsUpdateSaga);

  yield takeLatest(types.CHANGE_PASSWORD, changePasswordSaga); 

  yield takeLatest(types.MASTER_RATE_CARD_LIST_AFFILIATE, aflt_masterratecardListSaga);
  yield takeLatest(types.COPY_MASTER_CARD_TO_CLIENT, copyMasterCardToClientSaga);
  yield takeLatest(types.COPY_CATEGORY_TO_CATEGORY, copyCategoryToCategorySaga);
  yield takeLatest(types.MASTER_RATE_CARD_UPDATE_AFFILIATE, aflt_masterratecardUpdateSaga);

  yield takeLatest(types.RATE_CARD_LIST, rateCardListSaga);
  yield takeLatest(types.RATE_CARD_UPDATE, rateCardUpdateSaga);

  yield takeLatest(types.CLIENT_LIST, clientListSaga);
  yield takeLatest(types.CLIENT_QUICK_ADD, clientQuickAddSaga);
  yield takeLatest(types.CLIENT_EDIT, clientEditSaga);
  yield takeLatest(types.CLIENT_ACTIVE_DEACTIVE, clientActiveDeactiveSaga);
  yield takeLatest(types.CLIENT_CMPNY_INFO_ADD, clientCompanyInfoAddSaga);
  yield takeLatest(types.CLIENT_PRMRY_CNCT_ADD, clientPrmryConctAddSaga);
  yield takeLatest(types.CLIENT_CMPNY_INFO_UPDATE, clientCompanyInfoUpdateSaga);
  yield takeLatest(types.CLIENT_PRMRY_CNCT_UPDATE, clientPrmryConctUpdateSaga);
  yield takeLatest(types.CLIENT_CONTACT_LIST, clientContactListSaga);
  yield takeLatest(types.CLIENT_CONTACT_ADD, clientContactAddSaga);
  yield takeLatest(types.CLIENT_IMPORT, clientCsvImportSaga);
  yield takeLatest(types.CLIENT_IMPORT_QUICK_FILE, clientCsvImportQuickFileSaga);
  yield takeLatest(types.CLIENT_CONTACT_IMPORT, clientContactCsvImportSaga);

  yield takeLatest(types.CREW_UNAPPROVED_COUNT, crewUnapprovedCountSaga);
  yield takeLatest(types.CREW_LIST, crewListSaga); 
  yield takeLatest(types.CREW_LIST_DOWNLOAD, crewListDownloadSaga); 
  yield takeLatest(types.CREW_TIMESHEET_LIST, crewTimesheetListSaga); 
  yield takeLatest(types.CREW_FEEDBACK_LIST, crewFeedbackListSaga); 
  yield takeLatest(types.CREW_NOTES_LIST, crewNotesListSaga); 
  yield takeLatest(types.CREW_NOTES_ADD, crewNotesAddSaga); 
  yield takeLatest(types.CREW_NOTES_DOCUMENT_ADD, crewNotesDocumentAddSaga); 
  yield takeLatest(types.CREW_NOTES_DOCUMENT_DELETE, crewNotesDocumentDeleteSaga); 

  yield takeLatest(types.CREW_ALL_LIST, crewAllListSaga);
  yield takeLatest(types.CREW_BASIC_INFO_ADD, crewBasicInfoAddSaga);
  yield takeLatest(types.CREW_BASIC_INFO_UPDATE, crewBasicInfoUpdateSaga);
  yield takeLatest(types.CREW_EDIT, crewEditSaga);
  yield takeLatest(types.CREW_AVAILABILITY, crewAvailabilitySaga);
  yield takeLatest(types.CREW_APPROVE, crewApproveSaga);
  yield takeLatest(types.CREW_CHIEF_APPROVE, crewChiefEligibilitySaga);
  yield takeLatest(types.CREW_IMPORT, crewCsvImportSaga);
  yield takeLatest(types.CREW_INDUCTION, crewInductionSaga);

  yield takeLatest(types.CREW_ACTIVE_DEACTIVE, crewDeleteSaga);
  yield takeLatest(types.CREW_SKILL_LIST, crewSkillListSaga);  
  yield takeLatest(types.CREW_SKILL_SAVE, crewSkillSaveSaga);
  yield takeLatest(types.CREW_AFFILIATE_SKILL_LIST, crewAffSkillListSaga);

  yield takeLatest(types.ASS_USER_EDIT, assUserEditSaga);
  yield takeLatest(types.ASS_USER_UPDATE, assUserUpdateSaga);
  yield takeLatest(types.ASS_USER_DELETE, assUserDeleteSaga); 
  yield takeLatest(types.ASS_USER_ACTIVATE, assUserActivateSaga); 
  yield takeLatest(types.ASSOCIATE_USER_DELETE, associateUserDeleteSaga); 
  yield takeLatest(types.ASS_USER_LIST, assUserListSaga);
  yield takeLatest(types.DEPARTMENT_LIST_ASSOC_USER, assUserDepartmentListSaga);
  yield takeLatest(types.ROLES_LIST_ASSOC_USER, assUserRolesListSaga);
  yield takeLatest(types.ASS_USER_ADD, assUserAddSaga);
  yield takeLatest(types.UPDATE_ASSO_MUTE_EMAIL, assMuteEmailSaga);
  yield takeLatest(types.UPDATE_ASSO_MUTE_PUSH, assMutePushSaga);
  
  yield takeLatest(types.DYNAMIC_FIELDS_LIST, dynamicFieldsListSaga);
  yield takeLatest(types.DYNAMIC_FIELDS_UPDATE, dynamicFieldsdUpdateSaga);
  yield takeLatest(types.DYNAMIC_FIELDS_DATA_SAVE, dynamicFieldsDataSaveSaga);
  yield takeLatest(types.DYNAMIC_FIELDS_MASTER_LIST, dynamicFieldsMasterListSaga);
  
  yield takeLatest(types.CLIENT_RATE_CARD_LIST, clientRateCardListSaga);
  yield takeLatest(types.CLIENT_RATE_CARD_UPDATE, clientRateCardUpdateSaga); 

  yield takeLatest(types.ACTIVITY_LOG_LIST, activityLogListSaga); 

  yield takeLatest(types.RESEND_EMAIL, resendEmailSaga); 
  yield takeLatest(types.PROFILE_ROLE, getProfileRoleSaga); 

  yield takeLatest(types.DOCUMENT_LIST, documentListSaga); 
  yield takeLatest(types.DOCUMENT_ADD, documentAddSaga); 
  yield takeLatest(types.DOCUMENT_EDIT, documentEditSaga);
  yield takeLatest(types.DOCUMENT_UPDATE, documentUpdateSaga); 
  yield takeLatest(types.DOCUMENT_DELETE, documentDeleteSaga); 
  yield takeLatest(types.DOCUMENT_FILE_SAVE, documentFileSaveSaga); 
  yield takeLatest(types.DOCUMENT_FILE_DELETE, documentFileDeleteSaga);
  yield takeLatest(types.DOCUMENT_SKILL_LIST, skillDocumentListSaga);
  yield takeLatest(types.DOCUMENT_STATUS_UPDATE, documentStatusUpdateSaga);
  yield takeLatest(types.PASSPORT_FILE_SAVE, passportFileSaveSaga); 
  yield takeLatest(types.VISA_FILE_SAVE, visaFileSaveSaga); 

  yield takeLatest(types.EVENT_LIST, eventListSaga);   
  yield takeLatest(types.EVENT_LIST_DOWNLOAD, eventListDownloadSaga);
  yield takeLatest(types.SHIFT_CREW_LIST_DOWNLOAD, shiftCrewListDownloadSaga);
  yield takeLatest(types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD, eventShiftsStaffListPDFDownloadSaga);
  yield takeLatest(types.EVENT_MESSAGES_LIST, listEventMessagesSaga);
  yield takeLatest(types.SEND_EVENT_MESSAGE, sendEventMessageSaga);
  yield takeLatest(types.SHIFT_TIME_CHANGE_REQUEST, shiftTimeChangeRequestSaga); 
  yield takeLatest(types.INVOICE_LIST_DOWNLOAD, invoiceListDownloadSaga);
  yield takeLatest(types.QUOTE_CLIENT_LIST, eventClientListSaga); 
  yield takeLatest(types.QUOTE_EVENT_LOCATION_LIST, quoteEventLocationListSaga); 
  yield takeLatest(types.EVENT_ADD, eventAddSaga); 
  yield takeLatest(types.EVENT_EDIT, eventEditSaga); 
  yield takeLatest(types.EVENT_UPDATE, eventUpdateSaga);
  yield takeLatest(types.QUOTE_ACCEPT, quoteAcceptSaga);
  yield takeLatest(types.QUOTE_REJECT, quoteDeclineSaga);
  yield takeLatest(types.EVENT_DELETE, eventDeleteSaga);
  yield takeLatest(types.EVENT_CANCEL, eventCancelSaga);
  yield takeLatest(types.QUOTE_REQUEST, quoteRequestSaga);
  yield takeLatest(types.QUOTE_ASS_USER_LIST, quoteAssUserListSaga);
  yield takeLatest(types.SHIFT_ADD, shiftAddSaga);
  yield takeLatest(types.EVENT_CLIENT_DETAILS, eventClientDetailsSaga);
  yield takeLatest(types.GENERATE_INVOICE, generateInvoiceSaga);
  yield takeLatest(types.EVENT_AFFILIATE_DETAILS, eventAffiliateDetailsSaga);
  yield takeLatest(types.EVENT_QUOTE_SUMMARY, quoteSummarySaga);
  yield takeLatest(types.EVENT_QUOTE_PREVIEW, eventQuotePreviewSaga);
  yield takeLatest(types.EVENT_SUMMARY, eventSummarySaga);
  yield takeLatest(types.EVENT_CREW_CHIEF_COUNT, eventGetCrewChiefCountSaga);
  yield takeLatest(types.QUOTE_SEND_CLIENT, quoteSendtoClientSaga); 
  yield takeLatest(types.INVOICE_SEND_CLIENT, invoiceSendtoClientSaga); 
  yield takeLatest(types.QUOTE_USER_ACTION_LOG, eventUserActionLogsSaga);
  yield takeLatest(types.SHIFT_INDIVIDUAL_DETAILS, shiftIndividualDetailsSaga); 
  yield takeLatest(types.SHIFT_EDIT, shiftEditSaga);    
  yield takeLatest(types.SHIFT_GET_DETAILS, shiftGetDetailsSaga);    
  yield takeLatest(types.SHIFT_LIST, shiftListSaga);  
  yield takeLatest(types.SHIFT_QUICK_UPDATE, quoteQuickUpdateSaga);  
  yield takeLatest(types.QUOTE_DOWNLOAD, quoteDownloadSaga);  
  yield takeLatest(types.INVOICE_DOWNLOAD, invoiceDownloadSaga);  
  yield takeLatest(types.EVENT_SHIFT_UPDATE, eventShiftUpdateSaga);  
  yield takeLatest(types.EVENT_CLIENT_AFFILIATE_LIST, eventClientAffiliateListSaga);  
  yield takeLatest(types.SHIFT_DELETE, shiftDeleteSaga);  
  yield takeLatest(types.EVENTS_CALENDAR_LIST, eventCalendarListSaga);  
  yield takeLatest(types.ADD_REMOVE_VEHICLE, addRemoveVehicleSaga);  
  yield takeLatest(types.CREW_AVAILABILITY_REPORT, crewAvailabilityReportSaga);  
  yield takeLatest(types.EVENT_CLIENT_DEPARTMENTS_LIST, clientDepartmentsByEventIdSaga);  
  yield takeLatest(types.CREW_AVAIL_SUMMARY_REPORT, crewAvailSummaryReportListSaga);
  yield takeLatest(types.SHIFT_CALENDAR_EVENT_LIST, shiftCalendarEventsListSaga);  
  yield takeLatest(types.SHIFT_CALENDAR_EVENT_SHIFT_LIST, shiftCalendarEventShiftsListSaga);  

  yield takeLatest(types.FCM_NOTIFI_TOKEN_SAVE, fcmNotifiTokenSaveSaga);
  yield takeLatest(types.FCM_NOTIFICATION_SEND, fcmNotificationSendSaga);  
  yield takeLatest(types.NOTIFICATIONS_FETCH, notificationsFetchSaga);  
  yield takeLatest(types.NOTIFICATION_READ, notificationReadSaga);  
  yield takeLatest(types.NOTIFICATIONS_FETCH_DROPDOWN, notificationsFetchDropDownSaga);  
  yield takeLatest(types.NOTIFICATIONS_ALL_MARK_AS_READ, notificationsAllMarkAsReadSaga);  

  yield takeLatest(types.COUNTRY_LIST, countryListSaga);  

  yield takeLatest(types.SHIFT_SUMMARY, shiftSummarySaga); // USED IN SHIFT DETAILS SLIDER
  
  yield takeLatest(types.SHIFT_SCHEDULE_LIST, shiftScheduleListSaga); 
  yield takeLatest(types.SHIFT_SCHEDULE_CREW, shiftScheduleCrewSaga); 
  yield takeLatest(types.SCHEDULE_SHIFT_CREW, scheduleShiftCrewSaga); 
  yield takeLatest(types.SHIFT_SUMMARY_ALL_CREW, shiftSummaryAllCrewSaga);
  yield takeLatest(types.SHIFT_SCHEDULE_CREW_SEND_REQUEST, shiftScheduleCrewRequestSaga); 
  yield takeLatest(types.SHIFT_SKILL_CREW_LIST, shiftSkillCrewListSaga); 

  yield takeLatest(types.LOGIN_CLIENT_AFFILIATE_LIST, loginClientAffiliateListSaga); 

  yield takeLatest(types.CREW_SCHEDULE_SHIFT_STATUS, crewScheduleShiftStatusSaga); 
  yield takeLatest(types.CREW_SCHEDULE_SHIFT_CHECKIN, crewScheduleShiftCheckInSaga); 
  yield takeLatest(types.CREW_SCHEDULE_SHIFT_CHECKOUT, crewScheduleShiftCheckOutSaga); 
  yield takeLatest(types.CREW_REMOVAL_FROM_SHIFT, crewRemovalFromShiftSaga); 
  
  yield takeLatest(types.TIMESHEET_LIST, timesheetListSaga); 
  yield takeLatest(types.TIMESHEET_DETAILS, timesheetDetailsSaga); 
  yield takeLatest(types.TIMESHEET_UPDATE, timesheetUpdateSaga); 
  yield takeLatest(types.TIMESHEET_SHIFT_LIST, timesheetShiftListSaga); 
  yield takeLatest(types.TIMESHEET_CSV_DOWNLOAD, timesheetCSVDownloadSaga); 
  yield takeLatest(types.TIMESHEET_SUMMARY_CSV_DOWNLOAD, timesheetSummaryCSVDownloadSaga); 

  yield takeLatest(types.FEEDBACK_LIST, feedbackListSaga); 
  yield takeLatest(types.FEEDBACK_DETAILS, feedbackDetailsSaga); 
  yield takeLatest(types.FEEDBACK_UPDATE, feedbackUpdateSaga); 
  yield takeLatest(types.FEEDBACK_STAR_RATING, feedbackUpdateStarRatingSaga); 
  yield takeLatest(types.CHIEF_REVIEWERS_LIST, feedbackGetChiefReviewersListSaga); 
  
  yield takeLatest(types.SCHEDULE_DATE_VIEW, scheduleDateViewSaga); 
  yield takeLatest(types.SCHEDULE_CREW_VIEW, scheduleCrewViewSaga); 

  yield takeLatest(types.TIMEZONES_LIST, timeZonesListSaga); 
  yield takeLatest(types.SHIFT_CANCEL, shiftCancelSaga); 

  yield takeLatest(types.FILTER_CLIENTS_LIST, filterClientsListSaga); 
  yield takeLatest(types.SHIFTS_FILTER_EVENTS_LIST, shiftsFilterEventsListSaga); 
  yield takeLatest(types.SHIFTS_FILTER_SHIFTS_LIST, shiftsFilterShiftsListSaga); 
  yield takeLatest(types.SHIFTS_FILTER_LOCATIONS_LIST, shiftsFilterLocationsListSaga);

  yield takeLatest(types.CREW_UNAVAILABILITY, crewUnavailabilitySaga);
  yield takeLatest(types.CREW_UNAVAILABILITY_PER_DATE, crewUnavailabilityPerDateSaga);
  yield takeLatest(types.UNAVAILABLE_CREW_LIST, unavailableCrewListSaga);
  yield takeLatest(types.SAVE_UNAVAILABILITY, saveUnavailabilitySaga);
  yield takeLatest(types.UPDATE_UNAVAILABILITY, updateUnavailabilitySaga);
  yield takeLatest(types.DELETE_UNAVAILABILITY, deleteUnavailabilitySaga);
  yield takeLatest(types.GET_UNAVAILABILITY, getUnavailabilitySaga);

  yield takeLatest(types.EVENTS_FILTER_EVENTS_LIST, eventsFilterEventsListSaga);
  yield takeLatest(types.EVENTS_FILTER_LOCATIONS_LIST, eventsFilterLocationsListSaga);

  yield takeLatest(types.SERVER_TIME_LIST, serverTimeListSaga);
  
  yield takeLatest(types.DASHBOARD_ACTION_REQUIRED_LIST, dashboardActionRequiredListSaga);
  yield takeLatest(types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST, dashboardClientActionRequiredListSaga);

  yield takeLatest(types.DASHBOARD_CHART_DATA_LIST, dashboardChartDataListSaga);
  yield takeLatest(types.DASHBOARD_CLIENT_CHART_DATA_LIST, dashboardClientChartDataListSaga);
  yield takeLatest(types.SHIFT_TIME_CHANGE_REQUEST_COUNT, shiftTimeChangeRequestCountSaga);
  
  yield takeLatest(types.SHIFT_SEQ_NUMBER, getNextShiftSeqNumberSaga);

  yield takeLatest(types.INVITE_AS_FRIEND, inviteAsFriendSaga);

  yield takeLatest(types.FEEDBACK_FILTER_EVENTS_LIST, feedbackFilterEventsListSaga);
  yield takeLatest(types.FEEDBACK_FILTER_REVIEWERS_LIST, feedbackFilterReviewersListSaga);

  yield takeLatest(types.LOGIN_AS_USER, loginAsUserSaga);

  yield takeLatest(types.PAY_LEVELS_LIST, payLevelsListSaga);
  yield takeLatest(types.PAY_LEVELS_ADD, payLevelsAddSaga);
  yield takeLatest(types.PAY_LEVELS_EDIT, payLevelsEditSaga);
  yield takeLatest(types.PAY_LEVELS_UPDATE, payLevelsUpdateSaga);
  yield takeLatest(types.PAY_LEVELS_DELETE, payLevelsDeleteSaga);

  yield takeLatest(types.SA_PROFILE_DETAILS, getSAProfileDetailsSaga);
  yield takeLatest(types.SA_PROFILE_DETAILS_UPDATE, updateSAProfileDetailsSaga);

  yield takeLatest(types.CERTIFICATES_LIST, certificatesListSaga);
  
  yield takeLatest(types.OMNU_POINTS_PP_LIST, ppSettingsListSaga);
  yield takeLatest(types.OMNU_POINTS_PP_ADD, ppSettingsAddSaga);
  yield takeLatest(types.OMNU_POINTS_PP_EDIT, ppSettingsEditSaga);
  yield takeLatest(types.OMNU_POINTS_PP_UPDATE, ppSettingsUpdateSaga);
  yield takeLatest(types.OMNU_POINTS_PP_DELETE, ppSettingsDeleteSaga);
  
  yield takeLatest(types.GET_AFFILIATE_CHEIF_BONUS, getAffiliateChiefBonusSaga);
  yield takeLatest(types.UPDATE_AFFILIATE_CHEIF_BONUS, updateAffiliateChiefBonusSaga);

  yield takeLatest(types.RATECARD_CHEIF_BONUS_GET, getRateCardChiefBonusSaga);
  yield takeLatest(types.RATECARD_CHEIF_BONUS_UPDATE, updateRateCardChiefBonusSaga);

  yield takeLatest(types.TIMESHEET_FILTER_EVENTS, timesheetFilterEventsSaga);
  yield takeLatest(types.TIMESHEET_FILTER_LOCATION, timesheetFilterLocationsSaga);
  yield takeLatest(types.TIMESHEET_FILTER_CREW, timesheetFilterCrewsSaga);
  yield takeLatest(types.TIMESHEET_FILTER_SKILL, timesheetFilterSkillsSaga);
  yield takeLatest(types.TIMESHEET_FILTER_DEPARTMENT, timesheetFilterDepartmentsSaga);

  yield takeLatest(types.VALIDATE_CLIENT_ADD, validateClientAddSaga);
  yield takeLatest(types.VALIDATE_CLIENT_DETAILS, validateClientDetailsSaga); 
  yield takeLatest(types.VALIDATE_EVENT_ADD, validateEventAddSaga); 
  yield takeLatest(types.VALIDATE_CREW_ADD, validateCrewAddSaga); 
  yield takeLatest(types.VALIDATE_CREW_DETAILS, validateCrewDetailsSaga);  

  yield takeLatest(types.EVENT_COMPLETE, eventCompleteSaga); 
  
  yield takeLatest(types.CLIENT_GET_CREW_CHIEF_BONUS, clientGetCrewChiefBonusSaga); 
  yield takeLatest(types.CLIENT_UPDATE_CREW_CHIEF_BONUS, clientUpdateCrewChiefBonusSaga); 

  yield takeLatest(types.CLIENT_CONTACT_DELETE, clientContactDeleteSaga); 

  yield takeLatest(types.UPDATE_SKILL_INDEX, updateSkillIndexSaga);

  yield takeLatest(types.EVENT_DISCOUNT_EDIT, editQuoteDiscountSaga);

  yield takeLatest(types.FILTER_AFFILIATE_LIST, filterAffiliatesListSaga);
  
  yield takeLatest(types.SKILL_SUGGESTION, skillSuggestionSaga);

  yield takeLatest(types.EVENT_SHIFTS_LIST, listEventShiftsSaga);
  yield takeLatest(types.EVENT_SHIFT_CREW_LIST, listEventShiftCrewSaga);

  yield takeLatest(types.SCHEDULE_DATE_VIEW_CALENDAR, schedulesDateViewCalendarSaga);
  yield takeLatest(types.SCHED_DATE_VIEW_CALENDAR_DATE, schedDateViewCalendarDateSaga);

  yield takeLatest(types.PROFILE_CLIENT_CATEGORY_LIST, profileClientCategoryListSaga);
  yield takeLatest(types.CLIENT_LIST_FOR_CATEGORIES, clientListForCategoriesSaga);
  yield takeLatest(types.CLIENT_FULL_LIST, clientFullListSaga);
  yield takeLatest(types.CLIENT_COMPANY_BASIC_INFO, clientBasicInfoSaga); 
  yield takeLatest(types.CLIENT_DEPARTMENTS_LIST, clientDepartmentsByClientIdSaga); 
  yield takeLatest(types.UNALLOCATED_SHIFTS_COUNT, getUnallocatedShiftsCountSaga); 
  yield takeLatest(types.LIST_INVOICE, listInvoiceSaga); 
  yield takeLatest(types.UPDATE_INVOICE, updateInvoiceSaga); 
  yield takeLatest(types.INVOICE_PREVIEW, invoicePreviewSaga); 
  
  //Vehicle Info -- start--
  yield takeLatest(types.LIST_VEHICLE_FIELDS_MASTER, listVehicleFieldsMasterSaga); 
  yield takeLatest(types.ADD_VEHICLE_FIELDS_MASTER, addVehicleFieldaMasterSaga); 
  yield takeLatest(types.UPDATE_VEHICLE_FIELDS_MASTER, updateVehicleFieldaMasterSaga); 
  yield takeLatest(types.DELETE_VEHICLE_FIELDS_MASTER, deleteVehicleFieldsMasterSaga); 
  
  yield takeLatest(types.LIST_FIELD_DETAILS, listFieldDetailsSaga); 
  yield takeLatest(types.SAVE_FIELD_DETAILS, saveFieldDetailsSaga); 
  yield takeLatest(types.DELETE_FIELD_DETAILS, deleteFieldDetailsSaga);

  yield takeLatest(types.LIST_VEHICLE_INFO, listVehicleInfoSaga); 
  yield takeLatest(types.SAVE_VEHICLE_INFO, saveVehicleInfoSaga); 
  yield takeLatest(types.UPDATE_VEHICLE_INFO, updateVehicleInfoSaga); 
  yield takeLatest(types.DELETE_VEHICLE_INFO, deleteVehicleInfoSaga);  
  yield takeLatest(types.GET_VEHICLE_INFO, getVehicleInfoSaga);  
  yield takeLatest(types.AVAILABLE_AFF_VEHICLE, availableAffVehicleSaga);  
  yield takeLatest(types.ADD_AFF_VEHICLE, addAffVehicleSaga);  
  yield takeLatest(types.REMOVE_AFF_VEHICLE, removeAffVehicleSaga);
  yield takeLatest(types.ADD_AFF_VEHICLE_SHIFT, addAffVehicleShiftSaga);  
  yield takeLatest(types.REMOVE_AFF_VEHICLE_SHIFT, removeAffVehicleShiftSaga);  
  yield takeLatest(types.ADD_REMOVE_VEHICLE_SHIFT, addRemoveVehicleShiftSaga);  
  yield takeLatest(types.CANCELLED_REASON_LIST, cancelReasonListSaga);  
  //Vehicle Info -- end--

  //CancelReasons -- START -- 
  yield takeLatest(types.CANCEL_REASONS_MASTER_LIST, cancelReasonsMasterListSaga); 
  yield takeLatest(types.CANCEL_REASONS_MASTER_ADD, cancelReasonsMasterAddSaga);  
  yield takeLatest(types.CANCEL_REASONS_MASTER_LOAD, cancelReasonsMasterLoadSaga);  
  yield takeLatest(types.CANCEL_REASONS_MASTER_MODIFY, cancelReasonsMasterModifySaga); 
  yield takeLatest(types.CANCEL_REASONS_MASTER_DELETE, cancelReasonsMasterDeleteSaga); 
  yield takeLatest(types.CANCEL_REASONS_LIST, cancelReasonsListSaga); 
  yield takeLatest(types.CANCEL_REASONS_ADD, cancelReasonsAddSaga);  
  yield takeLatest(types.CANCEL_REASONS_LOAD, cancelReasonsLoadSaga);  
  yield takeLatest(types.CANCEL_REASONS_MODIFY, cancelReasonsModifySaga); 
  yield takeLatest(types.CANCEL_REASONS_DELETE, cancelReasonsDeleteSaga); 
  //CancelReasons -- END --
    
  //Terms & Conditions -- START -- 
  yield takeLatest(types.TERMS_FETCH, termsFetchSaga);    // FOR SUPERADMIN ONLY
  yield takeLatest(types.TERMS_ADD, termsAddSaga);        // FOR SUPERADMIN ONLY
  yield takeLatest(types.TERMS_UPDATE, termsUpdateSaga);  // FOR SUPERADMIN ONLY
  yield takeLatest(types.TERMS_LOAD, termsLoadSaga);      // FOR AFFILIATES AND CLIENTS
  yield takeLatest(types.TERMS_ACCEPT, termsAcceptSaga);  // FOR AFFILIATES AND CLIENTS
  //Terms & Conditions -- END --

  //Feedback ActionTaken -- START -- 
  yield takeLatest(types.ACTION_TAKEN_SHIFT, actionTakenShiftGetSaga);     
  yield takeLatest(types.ACTION_TAKEN_SHIFT_UPDATE, actionTakenShiftUpdateSaga);         
  yield takeLatest(types.ACTION_TAKEN_CREW, actionTakenCrewGetSaga);  
  yield takeLatest(types.ACTION_TAKEN_CREW_UPDATE, actionTakenCrewUpdateSaga);       
  //Feedback ActionTaken -- END --

  // CSV TEMPLATES IMPORT -- START -- 
  yield takeLatest(types.CSV_TEMPLATE_IMPORT, csvTemplateImportSaga);     
  // CSV TEMPLATES IMPORT -- END --
  

  //SHIFT CALCULATE DISTANCE BETWEEN DEPARTMENT AND LOCATION
    yield takeLatest(types.SHIFT_CALC_DISTANCE_DEPT_LOC, shiftCalcDistanceDeptLocSaga);  

}